<template>
  <div class="PublishContribution">
    <div class="pcWords">
      <div class="top">
        <h5>勞動部勞動力發展署國人海外就業資訊中心_誠摯歡迎您投稿！</h5>
        <p>
          親愛的全球海外就業國人們，<br />
          期盼您分享親身經歷與體驗，<br />
          讓欲前往海外就業的後行者，<br />
          皆能有最完善的參考與準備。
        </p>
      </div>
      <p>
        <!-- ---------------------------------------------------------------------投稿流程--------------------------------------------------------------------- -->
        <br />
      </p>
      <h5>【活動投稿規範】</h5>
      <div class="pic">
        <img src="../img/Contribute.jpg" alt="投稿流程圖" />
      </div>

      <div class="content">
        <h5>一、投稿說明：</h5>
        <p>
          1.本中心網站定位為非營利之政府機構資訊分享平台，旨在希望海內外國人皆能透過此平台，發揮原創共享精神，所有經採用投稿內容，皆為無酬關係(特定活動以該活動辦法及獎勵宣告為最終解釋)。
          <br />2.本中心歡迎海內外國人踴躍投稿，同時採雙向匿名審查，請投稿人務必確實填寫匿名與聯繫E-mail(必填資訊)，以利後續審查與通知聯繫。
          <br />3.若經發現投稿內容或個人資訊有造假及不實之疑，本中心有權利婉拒上稿外，投稿人需自行承擔衍生情事有關法律責任。
          <br />4.投稿經本中心上稿後，視同投稿人同意本中心得以數位方式為必要之重製、公開傳輸、授權用戶下載及列印等行為。為符合資料庫編輯之需要，並得進行格式之變更。
          <br />5.投稿人應秉持對本中心網站「原創共享」之投稿精神原則。投稿內容應不得為已經刊登於其他媒體/平台（包含個人社群頁面、粉絲團、部落格），及著作權已為買斷或已有稿費收益之文章。
          <br />6.投稿附帶圖片亦應為自身原始攝影檔，或經公開授權使用宣告之素材。如違反本項規範，投稿者需自行承擔侵犯著作權之有關法律責任，同時本中心有權利婉拒不採用。
          <br />7.投稿內容之建議及注意事項：
          <br />&nbsp;&nbsp;&nbsp;7-1.投稿內容應與投稿主題文字意義相符，並以繁體中文上傳，單篇字數建議為600至1200字(系統輸入上限為2000字)，文字量過多時，建議投稿人調整聚焦單向主題，重新分篇調整後提供符合字數量之投稿內容。
          <br />&nbsp;&nbsp;&nbsp;7-2.每篇投稿內容附帶至少一張圖片，並請提供該圖片之描述說明文字。
          <br />&nbsp;&nbsp;&nbsp;7-3.投稿內容必須為自身經驗原創，分享面向主要為在該國就業(打工)時，需特別注意之重要經驗分享，亦或在當地好用的資訊平台，及當下就業(打工)正接觸到的相關時事。
          <br />8.本中心網站保有採用與否之決定權。五個工作天後尚未收到回覆，歡迎另投他處。針對獲刊稿件，本站保有刪修及編輯的權利。
          <br />9.為符合國人期待，同時提供大眾正確資訊價值，本中心網站有對投稿內容執行潤稿及最終圖文修正權利，投稿者可於網站瀏覽最終上稿呈現內容，若有任何爭議之處，可隨時來信本中心。
        </p>
        <br />
        <h5>二、著作權宣告事項：</h5>
        <p>
          經採用之投稿內容，使用權由勞動部勞動力發展署本中心網站與投稿者共同持有，除本網站外，本中心亦能刊載於其他與本網站合作之任何(含電子)媒體平台，同時無條件視為同意本中心網站可進行使用、修改、重製、改作、散布、發行、公開發表、公開傳輸、翻譯該等資料。
        </p>
        <br />
        <h5>三、採用/不採用原則說明：</h5>
        <p>
          違反以下事項者，本中心審核小組將視為「不採用」，請投稿人閱讀及確實遵守，未違反以下事項者，審核小組將予以「採用」，特殊案例則依實際個案審核及回覆。
          <br />
          <br />1.單篇投稿字數低於600字者，不予採用(請自行檢視再行投稿)。
          <br />2.投稿字體為中文繁體外語言，不予採用(請自行檢視再行投稿)。
          <br />3.經評審小組查證或接獲舉報，投稿內容非投稿人原創者，不予採用(並即時下架)。
          <br />4.公開個人資料（真實姓名、電話/手機、電子郵件、通訊軟體ID、交友軟體ID…等），不予採用。
          <br />5.中傷、歧視、挑釁或謾罵他者，對特定人物名及族群，使用歧視、挑釁、謾罵他人、不雅字詞與
          人身攻擊…等文字言論，不予採用。
          <br />6.以下惡意、重複、近似性投稿，不予採用：
          <br />&nbsp;&nbsp;&nbsp;6-1.重複投稿與他人完全相同內容。
          <br />&nbsp;&nbsp;&nbsp;6-2.重複投稿自身投稿過相同內容。
          <br />&nbsp;&nbsp;&nbsp;6-3.大量空白或無意義字詞符號。
          <br />&nbsp;&nbsp;&nbsp;6-4.與現有存在國家/主題/內容(70%)近似者。
          <br />7.投稿內容含有情色裸露、恐怖血腥、任何鼓吹暴力犯罪，不予採用。
          <br />8.投稿內容與本中心無關之廣告及商業宣傳，不予採用。
          <br />9.投稿內容空泛或無明顯意義與分享價值，或與海外就業範疇無關，不予採用。
          投稿範疇參考：自身經歷之海外就業(含短期度假打工)有關：就業(打工)國家選擇評估、文件申辦
          過程、就業前準備及有用資料(網站)、就業當地環境(職場文化/人文思想/宗教風俗…等)、最新修
          訂法規、醫療保險資源、緊急救助措施(公/私立單位資源)、現況與轉職或返國心情分享…等。
          <br />10.未經當事人同意或客觀查證下，刻意散播不實經查證者，不予採用。
          <br />※以上未提及載明事項，皆以實際內容作為審理，並統一以email回覆採用結果。
        </p>
      </div>
    </div>
    <hr />
    <div class="notice">
      <a
        class="pcBtn"
        href="/files/Contribute_example.png"
        title="投稿範例下載.png"
        download="國人海外_達人投稿範例"
      >
        <DownloadOutlined class="download" />
        投稿範例下載
      </a>
      <p>提醒您!本中心投稿機制無暫存功能，請預先準備好內容後，在頁面內填入。</p>
    </div>

    <hr />
    <div class="type">
      <div>
        <a-form
          ref="formHeaderRef"
          :model="formState"
          :rules="rules"
          layout="inline"
        >
          <a-form-item
            label="投稿國家"
            name="region"
            ref="region"
            required
            title="投稿國家欄"
          >
            <select
              :value="formState.region"
              class="ant-input"
              placeholder="請選擇投稿國家"
              title="投稿國家"
              v-model="formState.region"
            >
              <option
                :value="country.countryId.toString()"
                v-for="country in p_submit.selectCountry"
                :key="country.countryId"
                title="投稿國家"
              >
                {{ country.countryName }}
              </option>
            </select>
          </a-form-item>
          <a-form-item
            for="theme"
            ref="theme"
            label="投稿主題"
            name="theme"
            style="width: 70%"
          >
            <a-input
              id="theme"
              v-model:value.trim="formState.theme"
              placeholder="請輸入投稿主題，此欄位最多輸入30字"
              title="請輸入投稿主題"
            />
          </a-form-item>
        </a-form>
      </div>
      <!-- 文章輸入區 -->
      <div>
        <a-form
          layout="vertical"
          ref="formContentRef"
          :model="formState"
          :rules="rules"
        >
          <a-form-item
            label="投稿內容"
            class="content"
            for="contentArea"
            name="content"
            title="投稿內容欄"
          >
            <a-textarea
              id="contextArea"
              v-model:value="formState.content"
              placeholder="請輸入投稿內容，每篇上限為2000字。"
              showCount
              :maxlength="2000"
              :auto-size="{ minRows: 15, maxRows: 110 }"
              title="投稿內容輸入框"
            />
          </a-form-item>
        </a-form>
      </div>

      <!-- 圖片上傳區 -->
      <div class="ImgArea">
        <div class="ia01">
          <!-- test upload -->
          <div class="ia001 gg">
            <input
              id="customFileInput1"
              type="file"
              accept="image/*"
              title="投稿主題欄"
              @change="updateImgList($event, 0)"
            />
            <label
              for="customFileInput1"
              class="chooseBtn"
              style="
                border: 2px solid;
                padding: 5px;
                border-radius: 6px;
                color: #024d73;
                align-self: baseline;
              "
            >
              <p class="choose_img" :style="{ fontSize: fontSize.p + 'em' }">
                選擇檔案 1
              </p>
            </label>
            <p :style="{ fontSize: fontSize.p + 'em' }" class="ellipsis">
              {{ imgList[0].name }}
            </p>
          </div>
          <div class="ia002">
            <a-form ref="formImgRef" :model="formState" :rules="rules">
              <a-form-item
                label="圖片1描述"
                for="pic_wrap01"
                name="imgDescription1"
              >
                <a-input
                  v-model:value.trim="formState.imgDescription1"
                  id="pic_wrap01"
                  placeholder="此欄位最多輸入20字"
                  title="圖片描述"
                /> </a-form-item
            ></a-form>
          </div>
        </div>
        <!--  -->
        <div class="ia01" v-for="(item, i) in 3" :key="i">
          <!-- test upload -->
          <div class="ia001 uu">
            <input
              :id="`customFileInput${i + 2}`"
              type="file"
              accept="image/*"
              title="選擇檔案鈕"
              @change="updateImgList($event, i + 1)"
            />
            <label
              :for="`customFileInput${i + 2}`"
              class="chooseBtn"
              style="
                border: 2px solid;
                padding: 5px;
                border-radius: 6px;
                color: #024d73;
                align-self: baseline;
              "
            >
              <p class="choose_img" :style="{ fontSize: fontSize.p + 'em' }">
                選擇檔案 {{ i + 2 }}
              </p>
            </label>
            <p :style="{ fontSize: fontSize.p + 'em' }" class="ellipsis">
              {{ imgList[i + 1].name }}
            </p>
          </div>
          <div class="ia002">
            <a-form ref="formImgDesRef" :model="formState" :rules="rules">
              <a-form-item
                :label="`圖片${i + 2}描述`"
                class="uu"
                :for="`pic_wrap0${i + 2}`"
                :name="`imgDescription${i + 2}`"
              >
                <a-input
                  :id="`pic_wrap0${i + 2}`"
                  v-model:value="formState[`imgDescription${i + 2}`]"
                  placeholder="此欄位最多輸入20字"
                  title="圖片描述"
                />
              </a-form-item>
            </a-form>
          </div>
        </div>

        <p :style="{ fontSize: fontSize.p + 'em' }" class="notice notice_size">
          圖片上傳注意事項 :
          最佳圖片尺寸(720*405像素)(72dpi)，每張上傳圖片大小限制為 1M
        </p>
      </div>

      <!-- 身分填寫區 -->
      <div class="contactArea">
        <a-form
          ref="formFooterRef"
          :model="formState"
          :rules="rules"
          class="caForm"
        >
          <a-form-item label="投稿暱稱" name="nickName" for="Contribution">
            <a-input
              v-model:value="formState.nickName"
              placeholder="請輸入投稿暱稱，此欄位最多輸入10字"
              id="Contribution"
              title="投稿暱稱"
            ></a-input>
          </a-form-item>
          <a-form-item label="聯絡信箱" name="email" for="Email">
            <a-input
              v-model:value="formState.email"
              placeholder="請輸入聯絡信箱"
              id="Email"
              title="聯絡信箱"
            ></a-input>
          </a-form-item>
        </a-form>
      </div>
      <button class="agreeBtn" @click="onSubmit" value="送出">
        <p :style="{ fontSize: fontSize.h4 + 'em' }">
          同意以上使用規範，確認送出。
        </p>
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, inject } from "vue";
import { apiContributorInfo, apiContributorAdd } from "@/api/api.js";
import { useRouter } from "vue-router";
import { DownloadOutlined } from "@ant-design/icons-vue";
import { emailValidate } from "@/func.js";
import Swal from "sweetalert2";

export default defineComponent({
  name: "Publish_submit",
  components: {
    DownloadOutlined,
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    const router = useRouter();
    const formHeaderRef = ref();
    const formContentRef = ref();
    const formImgRef = ref();
    const formImgDesRef = ref();
    const formFooterRef = ref();
    const formState = reactive({
      theme: "",
      region: "",
      nickName: "",
      email: "",
      content: "",
      imgDescription1: "",
      imgDescription2: "",
      imgDescription3: "",
      imgDescription4: "",
    });

    // 規範確認
    const isAllow = ref(true);

    //選擇檔案
    const imgList = ref([
      { name: "" },
      { name: "" },
      { name: "" },
      { name: "" },
    ]);
    const rules = {
      region: [
        {
          required: true,
          message: "請選擇投稿國家",
          trigger: "change",
        },
      ],
      theme: [
        {
          required: true,
          message: "請輸入投稿主題",
          trigger: "blur",
        },
        {
          min: 2,
          max: 30,
          message: "投稿主題長度限制2-30字元",
          trigger: "blur",
        },
      ],
      content: [
        {
          required: true,
          message: "投稿內容不可為空",
          trigger: "blur",
        },
        {
          min: 600,
          max: 2000,
          message: "投稿內容須為600-2000字元",
          trigger: "blur",
        },
      ],
      imgDescription1: [
        {
          required: true,
          message: "請輸入圖片描述",
          trigger: "blur",
        },
        {
          max: 20,
          message: "圖片描述不可超過20字元",
          trigger: "blur",
        },
      ],
      imgDescription2: [
        {
          max: 20,
          message: "圖片描述不可超過20字元",
          trigger: "blur",
        },
      ],
      imgDescription3: [
        {
          max: 20,
          message: "圖片描述不可超過20字元",
          trigger: "blur",
        },
      ],
      imgDescription4: [
        {
          max: 20,
          message: "圖片描述不可超過20字元",
          trigger: "blur",
        },
      ],
      nickName: [
        {
          required: true,
          message: "請輸入投稿暱稱",
          trigger: "blur",
        },
        {
          min: 1,
          max: 10,
          message: "投稿暱稱長度限制1-10字元",
          trigger: "blur",
        },
      ],
      email: [
        {
          required: true,
          validator: emailValidate,
          trigger: "blur",
        },
      ],
    };
    const resetForm = () => {
      formHeaderRef.value.resetFields();
      formContentRef.value.resetFields();
      formImgRef.value.resetFields();
      formImgDesRef.value.resetFields();
      formFooterRef.value.resetFields();
      formState.imgDescription2 = "";
      formState.imgDescription3 = "";
      formState.imgDescription4 = "";
      imgList.value = [{ name: "" }, { name: "" }, { name: "" }, { name: "" }];
    };
    const onSubmit = async () => {
      // ** 同意規範
      if (!isAllow.value) {
        Swal.fire("未同意活動注意事項", "您必須點選同意才能投稿", "warning");
        return;
      }
      // **1. 必填審核
      let canSubmit = true;
      await formHeaderRef.value.validate().catch(() => {
        canSubmit = false;
      });
      await formContentRef.value.validate().catch(() => {
        canSubmit = false;
      });
      await formImgRef.value.validate().catch(() => {
        canSubmit = false;
      });
      await formFooterRef.value.validate().catch(() => {
        canSubmit = false;
      });
      await formImgDesRef.value.validate().catch(() => {
        canSubmit = false;
      });
      if (!imgList.value[0].name) {
        canSubmit = false;
        Swal.fire("圖片上傳錯誤", "未上傳必填圖檔", "warning");
      }
      if (!!imgList.value[1].name !== !!formState.imgDescription2) {
        Swal.fire("圖片上傳錯誤", "圖檔與圖片描述不可單獨上傳", "warning");
        canSubmit = false;
      }
      if (!!imgList.value[2].name !== !!formState.imgDescription3) {
        Swal.fire("圖片上傳錯誤", "圖檔與圖片描述不可單獨上傳", "warning");
        canSubmit = false;
      }
      if (!!imgList.value[3].name !== !!formState.imgDescription4) {
        Swal.fire("圖片上傳錯誤", "圖檔與圖片描述不可單獨上傳", "warning");
        canSubmit = false;
      }

      //  上傳
      if (canSubmit) {
        // ** 2. 上傳圖檔要剔除空值
        // 圖檔
        const submitImgList = imgList.value.filter(
          (imgFile) => imgFile.name !== ""
        );
        let imgDesList = [
          formState.imgDescription1,
          formState.imgDescription2,
          formState.imgDescription3,
          formState.imgDescription4,
        ];
        const submitImgDescription = imgDesList.filter((des) => des !== "");
        //  **3. 上傳資料
        const data = {
          CountryId: formState.region,
          PageTitle: formState.theme,
          PageContent: formState.content,
          PosterName: formState.nickName,
          PostEmail: formState.email,
          Files: submitImgList,
          Des: submitImgDescription,
        };

        // **4. call api
        apiContributorAdd(data)
          .then((res) => {
            resetForm();
            Swal.fire("送出成功!", "您已成功投稿", "success");
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire("送出失敗!", error.response.data, "error");
          });
      }
    };

    function updateImgList(e, i) {
      const file = e.target.files[0];
      if (file.size > 1048576)
        Swal.fire("圖片過大", "您所上傳圖片超過大小限制", "warning");
      else imgList.value[i] = file;
    }

    const p_submit = reactive({
      pageId: "",
      nodeName: "",
      countryId: "",
      pageTitle: "",
      pageContent: "",
      selectCountry: [],
    });

    //取得頁面說明資料
    apiContributorInfo()
      .then((res) => {
        p_submit.nodeName = res.data.nodeName;
        p_submit.pageId = res.data.pageId;
        p_submit.countryId = res.data.countryId;
        p_submit.pageTitle = res.data.pageTitle;
        p_submit.pageContent = res.data.pageContent;
        p_submit.selectCountry = res.data.selectCountry;
      })
      .catch((err) => {
        console.log(err);
      });

    return {
      router,
      formHeaderRef,
      formContentRef,
      formImgRef,
      formImgDesRef,
      formFooterRef,
      other: "",
      formState,
      rules,
      onSubmit,
      resetForm,
      p_submit,
      fontSize,
      imgList,
      updateImgList,
      isAllow,
    };
  },
});
</script>

<style lang="scss" scoped>
hr {
  border: solid 3px $main_color;
  margin: 10px 0;
}
.ant-input {
  padding: 5px;
}

input[accept="image/*"] {
  opacity: 0;
  z-index: -10;
  position: absolute;
}
.PublishContribution {
  text-align: left;
  .pcWords {
    padding: 20px;
    ul {
      li {
        margin-bottom: 10px;
      }
    }
  }

  .type {
    .ImgArea {
      background-color: rgb(245, 245, 245);
      padding: 20px;
      margin: 50px 0;
      border-radius: 5px;
      .ia01 {
        .gg::before {
          display: inline-block;
          margin-right: 4px;
          color: #ff4d4f;
          font-size: 0.875em;
          font-family: SimSun, sans-serif;
          line-height: 1;
          content: "*";
        }
        .uu::before {
          display: inline-block;
          margin-right: 4px;
          color: #ff4d5000;
          font-size: 0.875em;
          font-family: SimSun, sans-serif;
          line-height: 1;
          content: "*";
        }
        .chooseBtn {
          text-align: center;
          cursor: pointer;
          background-color: rgb(255, 255, 255);
          :hover {
            color: $green_color;
          }
        }
        .ia001 {
          display: flex;
          margin-bottom: 10px;
          p {
            align-items: center;
            margin-left: 0px;
            padding: 0px;
            font-size: 1em;
          }
          .ellipsis {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            // white-space: normal;
          }
        }
      }
    }
    .notice {
      text-align: center;
    }
    .contactArea {
      padding: 20px;
      border: 1px solid $hr_gray;
      border-radius: 6px;
      .caForm {
        width: 50%;
        @include lg {
          width: 100%;
        }
      }
    }
    .agreeBtn {
      display: inline-block;
      width: 100%;
      border: dashed $main_color 2px;
      text-align: center;
      padding: 15px;
      background-color: #fff;
      transition: cubic-bezier(0.075, 0.82, 0.165, 1) 0.3s;
      margin: 20px 0;
      &:hover {
        cursor: pointer;
        background-color: $main_color;
        p {
          color: $main_sec_color;
        }
      }
      p {
        color: $main_color;
      }
    }
  }
}

.top {
  text-align: center;
  margin-bottom: 24px;
}
.pic {
  width: 70%;
  margin: 0 auto;
}
h5 {
  font-weight: bold;
  margin-bottom: 8px;
}
.arrow {
  transform: translate(7px, -3px);
  margin-right: 24px;
}
.pcBtn {
  border: $main_color 2px solid;
  border-radius: 5px;
  padding: 5px;
  cursor: pointer;
  margin-right: 8px;
}
.btn_style {
  display: inline-block;
  font-size: 1.25em;
  padding-right: 8px;
  transform: translateY(-4px);
}
.notice {
  display: flex;
  align-items: center;
  p {
    color: #ff4d4f;
  }
  &.notice_size {
    justify-content: center;
  }
}
.conuntry_select {
  margin-right: 15px;
  @include lg {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }
}
.conuntry_select select {
  width: auto;
}
.red {
  color: #ff4d4f;
}
</style>
